import { render, staticRenderFns } from "./action.vue?vue&type=template&id=2e80f415&"
import script from "./action.vue?vue&type=script&lang=ts&"
export * from "./action.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports